import React from "react";
import { useSettings } from "hooks/useStore";

const Price = ({ value = 0, currency = "USD", omitCurrencyCode }) => {
	const formattedPrice = new Intl.NumberFormat("en-US", {
		style: "currency",
		currencyDisplay: "narrowSymbol",
		currency,
		maximumFractionDigits: 2,
		minimumFractionDigits: omitCurrencyCode ? 0 : 2,
	})
		.format(value)
		.replace(/\s/g, " ");

	const showCurrencyCode = !omitCurrencyCode && currency !== "USD";
	return showCurrencyCode ? `${formattedPrice} ${currency}` : formattedPrice;
};

const Skeleton = () => <span className="inline-block animate-pulse h-2.5 bg-gray-300 rounded-full w-10 my-1" />;

const Money = ({ value = 0, currency, markets, compareAtPrice = false,
	quantity = 1, omitCurrencyCode = false, bundleDiscount = false }) => {
	const { currencyCode, customerCountry, isClient } = useSettings(["currencyCode", "customerCountry", "isClient"]);

	if (!currencyCode && !isClient) return <Skeleton />;

	// if currency prop is passed, use it (e.g. for cart, third-party components)
	if (currency) {
		return <Price value={!bundleDiscount ? value : value * 0.9} currency={currency} omitCurrencyCode={omitCurrencyCode} />;
	}

	const countryLower = customerCountry.toLowerCase();
	// if markets exist and the country is in the predefined markets, use the market price
	if (markets && Object.hasOwn(markets, countryLower)) {
		const market = markets[countryLower];
		const priceValue = market[compareAtPrice ? "compareAtPrice" : "price"];

		if (compareAtPrice && priceValue == null) return null;
		return <Price value={!bundleDiscount ? priceValue * quantity : priceValue * quantity * 0.9}
			currency={market.currency} omitCurrencyCode={omitCurrencyCode} />;
	}
	// if the country is not in the predefined markets, use the default currency
	return <Price value={!bundleDiscount ? value : value * 0.9} currency={currencyCode} omitCurrencyCode={omitCurrencyCode} />;
};

export default Money;